import { useSelectSlice } from "@common/redux/selectors/useSelectSlice"
import { Layout } from "@kursk/components/Layout/Layout";
import { RecommendationsBlock } from "@kursk/components/ui/RecommendationsBlock/RecommendationsBlock";
import { recommendationSlice } from "@common/redux/slices/recommendation.slice";
import { Socials } from "../Home/Socials/Socials";
import { getEntitiesListTitle } from "@kursk/utils/getEntitiesListTitle";
import styles from './News.module.scss';
import { Filters } from "./Filters/Filters";
import { newsSlice } from "@common/redux/slices/entities.slice";
import { NewsGrid } from "./NewsGrid/NewsGrid";
import { SeoMetaTitles } from "@kursk/components/seo/SeoMetaTitles";
import { SubscribeFooterForm } from "@kursk/components/ui/SubscribeFooterForm/SubscribeFooterForm";
import { regionContent } from "@kursk/content/regionContent";
import { HeroBlock } from "@kursk/components/ui/HeroBlock/HeroBlock";
import { picksSlice } from "@common/redux/slices/picks";
import React from "react";
import { CatalogueTitle } from "@kursk/components/ui/CatalogueTitle/CatalogueTitle";

export const News = () => {
  const { total, meta, filters } = useSelectSlice(newsSlice);
  const { listEvents, listTouristRoutes, listPlaces } = useSelectSlice(recommendationSlice);
  const selectedTags = filters.allTags;
  const selectedTag = (meta.tags && selectedTags.length === 1) && meta.tags.find((tag) => tag._id === selectedTags[0]);
  const { bannersInCatalogs } = useSelectSlice(picksSlice);

  return (
    <Layout showSubscribePopup={false} page="news">
      <SeoMetaTitles
        page="news"
        selectedTag={selectedTag}
        titleOg={getEntitiesListTitle(meta.tags, selectedTags, 'новости')}
      />
      <HeroBlock banners={bannersInCatalogs} page="news"/>
      <section className={styles.section_content}>
        <div className={styles.header}>
          <CatalogueTitle
            tags={meta.tags}
            selectedTags={selectedTags}
            title={'новости'}
            dashTitle={'Найдено новостей'}
            total={total}
          />
        </div>
        <div className={styles.filters}>
          <Filters />
        </div>
        <div className={styles.items}>
          <NewsGrid />
        </div>
        <div className={styles.recommendationSection}>
          <RecommendationsBlock
            entityType={'events'}
            data={listEvents}
            title={'Рекомендуем посетить'}
            goTo={'/events'}
            goToTitle={'все события'}/>
        </div>
        <div className={styles.recommendationSection}>
          <RecommendationsBlock
            entityType={'places'}
            data={listPlaces}
            title={'Рекомендуем побывать'}
            goTo={'/places'}
            goToTitle={'все места'}/>
        </div>
        <div className={styles.recommendationSection}>
          <RecommendationsBlock
            entityType={'touristroutes'}
            data={listTouristRoutes}
            title={`Рекомендуем спланировать ${regionContent.entitiesNames.routes.genitive}`}
            goTo={'/touristroutes'}
            goToTitle={`все ${regionContent.entitiesNames.routes.plural}`}/>
        </div>
        <div className={styles.recommendationSection}>
          <SubscribeFooterForm/>
        </div>
        <div className={styles.section}>
          <Socials/>
        </div>
      </section>
    </Layout>
  );
}
